<template>
  <div class="shared-data">
    <h2>Shared Data</h2>
    <h4>Main</h4>
    <div class="info-form__body">
      <v-form ref="infoForm" class="info-form__main-form">
        <v-row class="row mt-3">
          <v-col cols="6">
            <v-combobox
              v-if="isFieldShared('assignmentTitle')"
              filled
              label="Assignment Title"
              :items="cueCopywriting ? [] : assignmentTitles"
              :append-icon="cueCopywriting ? '' : '$dropdown'"
              v-model="formValues.assignmentTitle"
              :rules="[rules.required]"
              hide-details
              @change="setFormValue({ key: 'assignmentTitle', value: $event })"
            ></v-combobox>
            <v-text-field
              v-else
              filled
              label="Assignment Title"
              hide-details
              disabled
              :value="differentValuesFieldText"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-if="isFieldIndividual('assignmentId')"
              filled
              label="Assignment ID"
              hide-details
              disabled
              :value="differentValuesFieldText"
            ></v-text-field>
            <v-text-field
              v-else
              filled
              label="Assignment ID"
              hide-details
              :value="formValues.assignmentId"
              @change="setFormValue({ key: 'assignmentId', value: $event })"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="4">
            <v-autocomplete
              filled
              label="Related Project"
              :items="projects"
              :loading="projectsLoading"
              v-model="formValues.relatedProject"
              item-text="name"
              hide-details
              return-object
              :rules="[rules.requiredObject]"
              @change="updateRelatedProjectSmartFields($event)"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              filled
              label="Department"
              :items="departmentOptions"
              item-text="value"
              return-object
              v-model="selectedDepartment"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              filled
              label="Related Client Requester"
              :items="clientRequestersList"
              v-model="formValues.clientRequester"
              :rules="[rules.required]"
              hide-details
              @change="setFormValue({ key: 'clientRequester', value: $event })"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="6">
            <v-autocomplete
              filled
              label="Related Purchase Order"
              :items="relatedPurchaseOrders"
              :loading="projectsLoading"
              v-model="formValues.po"
              item-text="purchaseOrderNumber"
              return-object
              hide-details
              :rules="cueLoc || cueCopywriting ? [] : [rules.requiredObject]"
              @change="setFormValue({ key: 'po', value: $event })"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="payPeriodMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedPayPeriod"
                  label="Pay Period"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  filled
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="formValues.payPeriod"
                @input="payPeriodMenu = false"
                @change="setFormValue({ key: 'payPeriod', value: $event })"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="6">
            <v-autocomplete
              filled
              label="PM"
              :items="pmList"
              v-model="dubEditorPM"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              filled
              label="Status"
              :items="statusOptions"
              v-model="assignmentStatus"
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="6">
            <v-text-field
              v-if="isFieldShared('assignmentDetail')"
              filled
              label="Assignment Detail"
              hide-details
              :value="formValues.assignmentDetail"
              @change="setFormValue({ key: 'assignmentDetail', value: $event })"
            ></v-text-field>
            <v-text-field
              v-else
              filled
              label="Assignment Detail"
              hide-details
              disabled
              :value="differentValuesFieldText"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-if="isFieldShared('requestType')"
              filled
              label="Request Type"
              :items="requestTypeOptions"
              hide-details
              :value="formValues.requestType"
              @change="setFormValue({ key: 'requestType', value: $event })"
            ></v-autocomplete>
            <v-text-field
              v-else
              filled
              label="Request Type"
              hide-details
              disabled
              :value="differentValuesFieldText"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="12">
            <v-autocomplete
              v-if="isFieldShared('geo')"
              filled
              label="GEO"
              :items="geoOptions"
              hide-details
              :value="formValues.geo"
              @change="setFormValue({ key: 'geo', value: $event })"
            ></v-autocomplete>
            <v-text-field
              v-else
              filled
              label="GEO"
              hide-details
              disabled
              :value="differentValuesFieldText"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="6">
            <v-text-field
              filled
              label="Email Subject Line"
              hide-details
              disabled
              v-model="formValues.emailSubjectLine"
              :rules="[rules.required]"
              @change="setFormValue({ key: 'emailSubjectLine', value: $event })"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              filled
              label="Media Type"
              hide-details
              :items="mediaTypeOptions"
              v-model="formValues.mediaType"
              @change="setFormValue({ key: 'mediaType', value: $event })"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="6">
            <v-autocomplete
              filled
              label="Keyword"
              hide-details
              :items="keywordOptions"
              v-model="formValues.keyword"
              @change="setFormValue({ key: 'keyword', value: $event })"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              label="Genre"
              hide-details
              v-model="formValues.genre"
              @change="setFormValue({ key: 'genre', value: $event })"
            ></v-text-field>
          </v-col>
        </v-row>
        <h4 class="mt-4">Notes & Files</h4>
        <v-row class="row mt-4 mx-1px">
          <v-col cols="12" 
            class="textarea-container relative"
            :class="{ expanded: isRelatedTextFocused }"
            ref="relatedTextContainer"
            @click.prevent="isRelatedTextFocused = true"
          >
            <div class="note--editor--overlay">
              <p class="note--editor--title">Related Text</p>
              <v-btn
                text
                small
                @click.prevent="openEditorModal('relatedText')"
                class="note--editor">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <div class="custom-textarea" v-html="cleanQuillOutput(formValues.relatedText)" />
          </v-col>
        </v-row>
        <v-row class="row mt-9 mx-1px">
          <v-col cols="12" 
            class="textarea-container"
            :class="{ expanded: isNoteToStaffFocused }"
            ref="noteToStaffContainer"
            @click.prevent="isNoteToStaffFocused = true"
          >
            <div class="note--editor--overlay">
              <p class="note--editor--title">Note to Staff</p>
              <v-btn
                text
                small
                @click.prevent="openEditorModal('note')"
                class="note--editor">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <div class="custom-textarea" v-html="cleanQuillOutput(formValues.note)" />
          </v-col>
        </v-row>
        <v-row class="row mt-9 mx-1px">
          <v-col cols="12" 
            class="textarea-container"
            :class="{ expanded: isNoteToManagersFocused }"
            ref="noteToManagersContainer"
            @click.prevent="isNoteToManagersFocused = true"
          >
            <div class="note--editor--overlay">
              <p class="note--editor--title">Note to Managers</p>
              <v-btn
                text
                small
                @click.prevent="openEditorModal('noteToManager')"
                class="note--editor note--editor--managers">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <div class="custom-textarea" v-html="cleanQuillOutput(formValues.noteToManager)" />
          </v-col>
        </v-row>
        <v-row class="row mt-6">
          <v-col cols="12">
            <v-text-field
              filled
              label="Link"
              hide-details
              v-model="formValues.filmLink"
              @change="setFormValue({ key: 'filmLink', value: $event })"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row mt-4">
          <v-col cols="12">
            <v-container class="pa-0">
              <div
                class="documents-dropzone"
                @dragenter.prevent="onDragEnter"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop('adminFiles', $event)"
                :class="{ 'dropzone--active': isDragOver }"
              >
                <v-file-input
                  v-model="adminFiles"
                  small-chips
                  multiple
                  hide-details
                  filled
                  label="Admin Documents (Visible to PMs)"
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                  @change="onFilesSelected('adminFiles', $event)"
                  @click:clear="onClearFiles('adminFiles')"
                ></v-file-input>
              </div>
            </v-container>
          </v-col>
        </v-row>
        <v-row class="row mt-4">
          <v-col cols="12">
            <v-container class="pa-0">
              <div
                class="documents-dropzone"
                @dragenter.prevent="onDragEnter"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop('staffFiles', $event)"
                :class="{ 'dropzone--active': isDragOver }"
              >
                <v-file-input
                  v-model="staffFiles"
                  small-chips
                  multiple
                  hide-details
                  filled
                  label="Shared Files (Visible For Staff)"
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                  @change="onFilesSelected('staffFiles', $event)"
                  @click:clear="onClearFiles('staffFiles')"
                ></v-file-input>
              </div>
            </v-container>
          </v-col>
        </v-row>
        <v-row class="row mt-4">
          <v-col cols="12">
            <v-container class="pa-0">
              <div
                class="documents-dropzone"
                @dragenter.prevent="onDragEnter"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop('workFiles', $event)"
                :class="{ 'dropzone--active': isDragOver }"
              >
                <v-file-input
                  v-model="workFiles"
                  small-chips
                  multiple
                  hide-details
                  filled
                  label="Work Files"
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                  @change="onFilesSelected('workFiles', $event)"
                  @click:clear="onClearFiles('workFiles')"
                ></v-file-input>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-top-transition"
      max-width="800px"
      v-model="noteEditorDialog"
      hide-overlay
      persistent
      no-click-animation
    >
      <v-card
        class="d-flex justify-space-around flex-wrap px-6 pt-md-2 pt-lg-4 pb-md-4 pb-lg-6"
      >
        <div id="app" class="w-100">
          <vue-editor v-model="editor" :editorToolbar="customOptions"></vue-editor>
        </div>
        <v-card-actions class="ml-auto pa-0 pt-2 align-end">
          <v-btn
            color="secondary"
            @click="saveNewNoteData"
            >Save</v-btn
          >
          <v-btn color="#494949" dark @click="closeNoteEditorDialog"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getAllProjects,
  getEnum,
  getSpecificEnum,
  getAssignments,
  getTasks,
  processTask,
  getEvents,
} from "@/utils/newDbUtils";
import { VueEditor } from 'vue2-quill-editor';
import { mapActions, mapGetters } from "vuex";

import { getAssignmentById } from "../../utils/newDbUtils";
export default {
  name: "SharedData",
  props: {
    assignmentFieldSections: {
      type: Object,
      default: () => ({
        shared: [],
        individual: [],
      }),
    },
  },
  components: {
    VueEditor
  },
  data() {
    return {
      projectsLoading: false,
      projects: [],
      payPeriodMenu: false,
      dubEditorPM: null,
      isRelatedTextFocused: false,
      isNoteToStaffFocused: false,
      isNoteToManagersFocused: false,
      adminFiles: [],
      staffFiles: [],
      workFiles: [],
      isDragOver: false,
      staffDatas: [],
      editor: '<h1>Start typing...</h1>',
      noteEditorDialog: false,
      noteEditorKey: 'note',
      customOptions: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
      amAssignmentTitles: [
        "P1 Playlist Copy",
        "P3 Playlist Copy",
        "Classical Playlist Copy",
        "Playlist Title",
      ],
      fcAssignmentTitles: [
        "Album Review",
        "Arcade File",
        "Artist Bio",
        "Artist Interview Edit",
        "Artist Interview Prep",
        "Artist Interview Transcript",
        "Book Review",
        "Custom Tag",
        "Custom Title",
        "Discovery File",
        "Editorial Feature",
        "Guidelines",
        "Hero Blurb",
        "Hourly Localization Work",
        "Interview Note",
        "Marketing Copy",
        "MAS File",
        "Meeting",
        "Movie Description",
        "P1 Playlist Copy",
        "P3 Playlist Copy",
        "Storefront Description",
        "Today File",
        "Vision Pro"
      ],
      rules: {
        required: (value) => !!value || value === 0 || "Required",
        requiredObject: (value) =>
          (value ? !!Object.keys(value).length : !!value) || "Required",
        dateAvailabile: (operation) =>
          this[`${operation}DueDateAvailable`] ||
          "Selected date is after delivery date for the client.",
        timeAvailabile: (operation) =>
          this[`${operation}DueHoursAvailable`] ||
          "Selected time is after delivery due (time of day) for the client.",
      },
    };
  },
  watch: {
    relatedProject(newVal) {
      if (this.projects.length && typeof newVal !== "object")
        this.updateRelatedProjectSmartFields(newVal);
    },
  },
  computed: {
    ...mapGetters("spreadsheetUpload", [
      "tableRows",
      "formValues",
      "staffAssignments",
      "xContent",
      "shakespeare",
      "shakespeareLoc",
      "backstageCopywriting",
      "cueLoc",
      "cueCopywriting",
      "dubEditor",
      "baseLocalization",
      "splitByPersonFilesAmount",
      "splitByPersonSend",
      "applyLocMinRate"
    ]),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("assignment", [
      "projectsList",
      "requestTypeOptions",
      "geoOptions",
      "mediaTypeOptions",
      "keywordOptions",
      "departmentOptions",
      "statusOptions",
    ]),
    differentValuesFieldText() {
      return "Different Values";
    },
    formattedPayPeriod: {
      get() {
        return this.formValues.payPeriod
          ? `${this.$moment(this.formValues.payPeriod).format("MM-YYYY")}`
          : null;
      },
      set() {
        this.formValues.payPeriod = null;
      },
    },
    assignmentStatus: {
      get() {
        if (!this.formValues.assignmentStatus) {
          this.setFormValue({
            key: "assignmentStatus",
            value: "Assigned",
          });
        }
        return this.formValues.assignmentStatus;
      },
      set(newVal) {
        this.formValues.assignmentStatus = newVal;
      },
    },
    selectedDepartment: {
      get() {
        if (this.formValues.department && typeof this.formValues.department === "object") {
          return this.formValues.department;
        }
        if (this.formValues.department && typeof this.formValues.department === "string") {
          const selectedDepartment = this.departmentOptions.find(
            (el) => el.value === this.formValues.department
          );
          if (selectedDepartment) return selectedDepartment;
        }
        if (this.tableRows?.length && this.tableRows[0]?.department) {
          const sourceDepartment = this.departmentOptions.find(
            (el) => el.value === this.tableRows[0].department
          );
          if (sourceDepartment) return sourceDepartment;
        }
        if ((this.shakespeare || this.shakespeareLoc) && this.departmentOptions?.length) {
          return this.departmentOptions.find((el) => el.value === "FC") || null;
        }
        return null;
      },
      set(newVal) {
        this.setFormValue({ key: "department", value: newVal });
      },
    },
    pmList() {
      const projectManager = this.relatedProject?.projectManager;
      const pmName = [projectManager?.firstName, projectManager?.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
      if (pmName) {
        this.dubEditorPM = pmName;
        return [pmName];
      }
      this.dubEditorPM = null;
      return [];
    },
    relatedProject() {
      return this.formValues.relatedProject;
    },
    relatedPurchaseOrders() {
      return this.formValues.relatedProject?.purchaseOrders?.filter(
        (el) => el.isActive
      );
    },
    clientRequestersList() {
      if (this.shakespeare) return ["Shakespeare"];
      const requesters = this.relatedProject?.clientRequesters;
      if (Array.isArray(requesters) && requesters.length) {
        return requesters.map((cr) => `${cr?.user?.firstName || ""} ${cr?.user?.lastName || ""}`.trim()).filter(Boolean);
      }
      return [];
    },
    assignmentTitles() {
      return this.shakespeare || this.backstageCopywriting
        ? [...this.amAssignmentTitles, ...this.fcAssignmentTitles].sort()
        : this.shakespeareLoc
        ? ["Arcade File", "Discovery File", "MAS File", "Today File"]
        : this.fcAssignmentTitles;
    },
  },
  methods: {
    ...mapActions("spreadsheetUpload", [
      "setFormValue",
      "updateCapacityData",
      "setStaffLoading",
      "setStaffAssignments",
      "setPrepopulation",
      "setApplyLocMinRate",
    ]),
    ...mapActions("assignment", [
      "setCommonData",
    ]),
    isFieldShared(fieldKey) {
      return this.assignmentFieldSections?.shared?.includes(fieldKey);
    },
    isFieldIndividual(fieldKey) {
      return this.assignmentFieldSections?.individual?.includes(fieldKey);
    },
    handleClickOutside(event) {
      const relatedEl = this.$refs.relatedTextContainer;
      const noteEl = this.$refs.noteToStaffContainer;
      const managersEl = this.$refs.noteToManagersContainer;

      if (relatedEl && !relatedEl.contains(event.target)) {
        this.isRelatedTextFocused = false;
      }
      if (noteEl && !noteEl.contains(event.target)) {
        this.isNoteToStaffFocused = false;
      }
      if (managersEl && !managersEl.contains(event.target)) {
        this.isNoteToManagersFocused = false;
      }
    },
    openEditorModal(key) {
      this.noteEditorDialog = true;
      this.noteEditorKey = key;
      console.log("this.formValues.note", this.formValues[key]);
      this.editor = this.formValues[key];
    },
    closeNoteEditorDialog() {
      this.noteEditorDialog = false;
      this.noteEditorKey = 'note'
      this.editor = '';
    },
    saveNewNoteData() {
      console.log('Saving editor content:', this.editor);
      this.setFormValue({
        key: this.noteEditorKey,
        value: this.editor,
      });
      this.closeNoteEditorDialog();
    },
    cleanQuillOutput(html) {
      if (!html) return "";
      return html
        .replace(/(<p><br><\/p>\s*){2,}/g, '<p><br></p>')
        .replace(/<p>\s*<\/p>/g, "")
        .replace(/<p(?![^>]*style=)/g, '<p style="margin-bottom: 0px"');
    },
    onDragEnter() {
      this.isDragOver = true;
    },
    onDragOver() {
      this.isDragOver = true;
    },
    onDragLeave() {
      this.isDragOver = false;
    },
    onDrop(type, event) {
      this.isDragOver = false;
      const droppedFiles = Array.from(event.dataTransfer.files);
      this[type] = [...this[type], ...droppedFiles];
      this.$emit("files-updated", {
        adminFiles: this.adminFiles,
        staffFiles: this.staffFiles,
        workFiles: this.workFiles,
      });
    },
    onFilesSelected(type, newFiles) {
      this[type] = newFiles;
      this.$emit("files-updated", {
        adminFiles: this.adminFiles,
        staffFiles: this.staffFiles,
        workFiles: this.workFiles,
      });
      console.log("this[type]", this[type]);
    },
    onClearFiles(type) {
      this[type] = [];
      this.$emit("files-updated", {
        adminFiles: this.adminFiles,
        staffFiles: this.staffFiles,
        workFiles: this.workFiles,
      })
    },
    handleBlur() {
      this.isRelatedTextFocused = false;
      this.isNoteToStaffFocused = false;
      this.isNoteToManagersFocused = false;
      this.$refs.relatedTextContainer.scrollTop = 0;
      this.$refs.noteToStaffContainer.scrollTop = 0;
      this.$refs.noteToManagersContainer.scrollTop = 0;
    },
    getMediaTypes() {
      getEnum("MediaType").then((data) => {
        this.setCommonData({ field: "mediaTypeOptions", data });
        this.mediaTypesLoading = false;
      });
    },
    getKeywords() {
      getSpecificEnum("keywords").then((resp) => {
        const options = Array.isArray(resp?.data)
          ? resp.data
              .map((item) =>
                typeof item === "string" ? item : item?.value
              )
              .filter((value) => !!value)
              .sort((a, b) => a.localeCompare(b))
          : [];
        this.setCommonData({ field: "keywordOptions", data: options });
        this.mediaTypesLoading = false;
      });
    },
    getAssignmentStatuses() {
      getEnum("AssignmentStatus").then((data) => {
        this.setCommonData({ field: "statusOptions", data: data });
      });
    },
    getProjects() {
      if (this.projectsList.length) {
        this.projects = this.projectsList;
        if (typeof this.relatedProject === "string")
          this.updateRelatedProjectSmartFields(this.relatedProject);
        return;
      }
      this.setStaffLoading(true);
      this.projectsLoading = true;
      getAllProjects()
        .then((data) => {
          this.projects = data;
          this.projectsLoading = false;
          if (typeof this.relatedProject === "string")
            this.updateRelatedProjectSmartFields(this.relatedProject);
        })
        .catch((err) => {
          console.error(err);
          this.setStaffLoading(false);
          this.projectsLoading = false;
        });
    },
    updateRelatedProjectSmartFields(selectedProject) {
      const resolvedProject =
        typeof selectedProject === "string"
          ? this.projects.find((el) => el.name === selectedProject)
          : selectedProject;
      this.setFormValue({
        key: "relatedProject",
        value: resolvedProject ?? null,
      });
      this.setFormValue({
        key: "po",
        value:
          typeof this.formValues.po !== "object"
            ? resolvedProject?.purchaseOrders?.find(
                (el) => el.purchaseOrderNumber == this.formValues.po
              )
            : resolvedProject?.purchaseOrders?.find((el) => el.isActive) ??
              null,
      });
      this.setStaffData();
    },
    setStaffData() {
      // mutate data according to already implemented API
      if (!this.relatedProject?.staff?.length) {
        this.staffDatas = [];
        this.setStaffLoading(false);
        return;
      }
      this.staffDatas = this.relatedProject.staff
        .map((el) => ({
          ...el,
          disabled: false,
          geos: el.adminDetails.geos,
          initials: el.adminDetails.initials,
          name: `${el.user.firstName} ${el.user.lastName}`,
          slackID: el.adminDetails.slackIdFc,
          cueSlackID: el.adminDetails.slackIdStaff,
        }))
        .sort((a, b) => a.user.firstName.localeCompare(b.user.firstName));
      this.setStaffLoading(false);
    },
  },
  mounted() {
    this.getProjects();
    this.getMediaTypes();
    this.getKeywords();
    this.getAssignmentStatuses();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
}
</script>

<style scoped lang="scss">
.shared-data {
  h4 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0%;
    margin: 15px 0;
  }
}

.textarea-container {
  position: relative;
  height: 55px;
  overflow: hidden;
  transition: height 0.3s ease;
  padding: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  cursor: text;
}

.note--editor {
  position: absolute;
  top: 10px;
  left: 10px;
}

.textarea-container.expanded {
  height: 350px;
  overflow-y: auto;
}

.mx-1px {
  margin-left: 1px;
  margin-right: 1px;
}

.documents-dropzone {
  text-align: center;
  transition: background-color 0.2s ease;
}
.documents-dropzone--active {
  background-color: #e3f2fd;
}

.note--editor--overlay {
  width: 100% !important;
  background-color: #f5f5f5;
  padding: 5px 16px 0 16px;
  .note--editor--title {
    color: #6b6b6b;
    margin-top: 3px;
  }
}
.note--editor {
  position: absolute;
  top: 0;
  left: 115px;
  z-index: 8;
  color: #6b6b6b;
  width: 25px !important;
  margin-top: 5px;
  &--managers {
    left: 150px;
  }
}
.custom-textarea {
  width: 100% !important;
  max-height: 350px;
  height: 100%;
  overflow-y: auto;
  border-radius: 4px;
  background-color: #f5f5f5;
  padding: 0 16px 16px 16px;
  min-height: 100px;
  border-bottom: 1px solid #ccc;
  white-space: normal;
  line-height: 1.6;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  margin-top: -17px;
}
</style>
